import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ExternalVariantLink extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  update = (event) => {

    if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      this.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newNode = event.detail?.data?.html?.querySelector('external-variant-link');
    if (!newNode) return;

    morph(this, newNode, { childrenOnly: true });
  };
}

if (!customElements.get('external-variant-link')) {
  customElements.define('external-variant-link', ExternalVariantLink);
}